import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Container } from 'react-bootstrap';
import logo from '../../assets/logo.png';

const Messages = () => {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/messages`);
      if (response.ok) {
        const data = await response.json();
        setMessages(data);
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsViewed = async (messageId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/messages/${messageId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: 'viewed' })
      });
      
      if (response.ok) {
        setMessages(messages.map(msg => 
          msg.id === messageId ? { ...msg, status: 'viewed' } : msg
        ));
      }
    } catch (error) {
      console.error('Error updating message status:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    navigate('/');
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <>
      <Navbar 
        expand="lg" 
        className="animated-nav-background"
        style={{ 
          boxShadow: '0 2px 10px rgba(232, 12, 129, 0.2)',
          padding: '1rem 0',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(232, 12, 129, 0.1)'
        }}
        variant="dark"
      >
        <Container>
          <Navbar.Brand href="/">
            <img 
              src={logo} 
              alt="Star Tidbits" 
              style={{ 
                height: '60px', 
                width: 'auto',
                maxWidth: '100%'
              }}
            />
          </Navbar.Brand>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', marginLeft: 'auto' }}>
            <h3 style={{ color: 'white', margin: 0, fontSize: '1.25rem' }}>Messages</h3>
            <button 
              onClick={() => navigate('/admin/dashboard')}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Dashboard
            </button>
            <button 
              onClick={() => navigate('/admin/products')}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Products
            </button>
            <button 
              onClick={handleLogout}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Logout
            </button>
          </div>
        </Container>
      </Navbar>
      
      <div style={{ padding: '2rem 0', minHeight: 'calc(100vh - 80px)', backgroundColor: 'var(--neutral-light)' }}>
        <div className="container">
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
              <h2>Contact Messages</h2>
              <span style={{ color: 'var(--primary-saffron)', fontWeight: '600' }}>
                {messages.length} total messages
              </span>
            </div>

            {loading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <p>Loading messages...</p>
              </div>
            ) : messages.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <p>No messages yet.</p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {messages.map((message) => (
                  <div 
                    key={message.id} 
                    className="card" 
                    style={{ 
                      backgroundColor: message.status === 'new' ? '#fff8f0' : 'white',
                      border: message.inquiryType === 'quality' 
                        ? '2px solid #dc3545' 
                        : message.inquiryType === 'general' 
                        ? '2px solid #007bff' 
                        : message.status === 'new' 
                        ? '1px solid var(--primary-saffron)' 
                        : '1px solid #ddd',
                      cursor: 'pointer',
                      fontWeight: message.status === 'new' ? 'bold' : 'normal'
                    }}
                    onClick={() => message.status === 'new' && markAsViewed(message.id)}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                      <div>
                        <h4 style={{ 
                          margin: 0, 
                          color: 'var(--primary-saffron)',
                          fontWeight: message.status === 'new' ? 'bold' : 'normal'
                        }}>
                          {message.subject}
                        </h4>
                        <p style={{ 
                          margin: '0.25rem 0', 
                          fontSize: '0.875rem', 
                          opacity: message.status === 'new' ? 1 : 0.7,
                          fontWeight: message.status === 'new' ? '600' : 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          {formatDate(message.createdAt)} • 
                          <span style={{
                            backgroundColor: message.inquiryType === 'quality' ? '#dc3545' : '#007bff',
                            color: 'white',
                            padding: '0.125rem 0.375rem',
                            borderRadius: '3px',
                            fontSize: '0.75rem',
                            fontWeight: '600',
                            textTransform: 'uppercase'
                          }}>
                            {message.inquiryType}
                          </span>
                        </p>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {message.status === 'new' && (
                          <span style={{ 
                            backgroundColor: 'var(--primary-saffron)', 
                            color: 'white', 
                            padding: '0.25rem 0.5rem', 
                            borderRadius: '4px', 
                            fontSize: '0.75rem',
                            fontWeight: '600'
                          }}>
                            NEW
                          </span>
                        )}
                        {message.status === 'viewed' && (
                          <span style={{ 
                            backgroundColor: '#28a745', 
                            color: 'white', 
                            padding: '0.25rem 0.5rem', 
                            borderRadius: '4px', 
                            fontSize: '0.75rem',
                            fontWeight: '600'
                          }}>
                            VIEWED
                          </span>
                        )}
                      </div>
                    </div>
                    
                    <div style={{ marginBottom: '1rem' }}>
                      <p style={{ 
                        margin: 0,
                        fontWeight: message.status === 'new' ? '600' : 'normal'
                      }}>
                        {message.message}
                      </p>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '1rem', borderTop: '1px solid #eee' }}>
                      <div>
                        <strong style={{ fontWeight: message.status === 'new' ? 'bold' : '600' }}>
                          {message.name}
                        </strong>
                        <br />
                        <a href={`mailto:${message.email}`} style={{ color: 'var(--primary-saffron)', textDecoration: 'none' }}>
                          {message.email}
                        </a>
                        {message.phone && (
                          <>
                            <br />
                            <a href={`tel:${message.phone}`} style={{ color: 'var(--primary-saffron)', textDecoration: 'none' }}>
                              {message.phone}
                            </a>
                          </>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <a 
                          href={`mailto:${message.email}?subject=Re: ${message.subject}&body=Hi ${message.name},%0D%0A%0D%0AThank you for contacting Star Tidbits.%0D%0A%0D%0A`}
                          className="btn btn-primary"
                          style={{ fontSize: '0.875rem' }}
                        >
                          Reply
                        </a>
                        {message.phone && (
                          <a 
                            href={`https://wa.me/${message.phone.replace(/[^0-9]/g, '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline"
                            style={{ fontSize: '0.875rem' }}
                          >
                            WhatsApp
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Messages;